module.exports = __webpack_public_path__ + "img/chevron-right.7042b97a.svg";